module.exports = __webpack_public_path__ + "static/img/code-2.b089e39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/code-2.png
// module id = gDDM
// module chunks = 0